import React, { useReducer, useState, useEffect } from 'react'
import AgencyContext from './agencyContext'
import AgencyReducer from './agencyReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_AGENCY,
    GET_SINGLE_AGENCY,
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
} from './agencyTypes'

const AgencyState = (props) => {
    const initialState = {
        single_agency: {
            record: {},
        },
        all_agency: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        responseStatus: null,
    }

    const [agencySelectedTab, setAgencySelectedTabState] = useState(() => {
        const savedTab = localStorage.getItem('agencySelectedTab')
        return savedTab ? parseInt(savedTab) : 0
    })

    const setAgencySelectedTab = (tabIndex) => {
        setAgencySelectedTabState(tabIndex)
        localStorage.setItem('agencySelectedTab', tabIndex)
    }

    const [state, dispatch] = useReducer(AgencyReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getSingleAgency = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getSingleAgency', formData, '', 'agency'),
            ])
            const from = fromVariable ? fromVariable : 'AgencyManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_AGENCY,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllAgency = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'allAgency', formData, '', 'agency'),
            ])
            const from = fromVariable ? fromVariable : 'AgencyManagement'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_AGENCY,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const agencyAction = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'agencyAction'
            const [res] = await Promise.all([
                apiCall('post', 'agencyAction', formData, '', 'agency'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeAgencyStatus = async (formData) => {
        try {
            const from = 'changeStatus'
            const [res] = await Promise.all([
                apiCall('post', 'changeStatus', formData, '', 'agency'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const addExistEmp = async (formData) => {
        try {
            const from = 'addExistEmp'
            const [res] = await Promise.all([
                apiCall('post', 'addExistEmp', formData, '', 'agency'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const syncAddressPaymentDesc = async (formData) => {
        try {
            const from = 'syncAddressPaymentDesc'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'syncAddressPaymentDesc',
                    formData,
                    '',
                    'agency'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })
    return (
        <AgencyContext.Provider
            value={{
                all_agency: state.all_agency,
                responseStatus: state.responseStatus,
                single_agency: state.single_agency,
                addExistEmp,
                clearResponse,
                getAllAgency,
                getSingleAgency,
                agencyAction,
                changeAgencyStatus,
                syncAddressPaymentDesc,
                agencySelectedTab,
                setAgencySelectedTab,
            }}
        >
            {props.children}
        </AgencyContext.Provider>
    )
}

export default AgencyState
